<template>
<div class="myPoints">
    <!-- <van-nav-bar
        title="我的积分"
        left-arrow
        @click-left="onClickLeft"
    /> -->
    <div class="myPoints-top">
        <div class="myPoints-nav-bar">
            <div class="left-icon" @click="onClickLeft"><van-icon name="arrow-left" /></div>
            <div class="bar-text">我的积分</div>
            <div class="pointsRules-text" @click="onClickRight">积分规则</div>
        </div>
        <div class="total-points">{{yxtIntegralInfoCount}}</div>
    </div>
    <div class="myPoints-content">
        <!-- <div class="myPoints-list">
            <div class="list-item">
                <div class="info">
                    <p class="title">
                    注册        
                    </p>
                    <p class="time">
                        2020.09.08 13:25:16   
                    </p>
                </div>
                <div class="integralNum">
                    +1
                </div>
            </div>
            <div class="list-item">
                <div class="info">
                    <p class="title">
                        课程学习   
                    </p>
                    <p class="name">
                        课程名称课程名称课程名称课程名称课  
                    </p>
                    <p class="time">
                       2020.09.08 13:25:16    
                    </p>
                </div>
                <div class="integralNum">
                    +8
                </div>
            </div>
        </div> -->
        <div class="myPoints-list" v-if="list.length">
            <div class="list-item" v-for="item in list" :key="item.id">
                <div class="info">
                    <p class="title">
                    {{item.integralType==1?'注册':item.integralType==2?'课程学习':''}}          
                    </p>
                    <p class="name" v-if="item.videoName">
                        {{item.videoName}}     
                    </p>
                    <p class="time">
                        {{item.integralTime}}    
                    </p>
                </div>
                <div class="integralNum">
                    +{{item.integralNum}}
                </div>
            </div>
        </div>
        <div v-else class="no-data">
            <img src="../../../assets/images/account/blank.png" class="blank-img"/>
            <p class="blank-txt">
                你还没积分哦，继续加油～
            </p>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'myPoints',
    data() {
        return {
            list: [],
            yxtIntegralInfoCount:0
        }
    },
    mounted(){
        this.getMyPoints()
        this.getData();
    },
    methods: {
        onClickRight(){
            this.$router.push({
				path: '/pointsRules',
			})
        },
        onClickLeft() {
            this.$router.go(-1);
        },
        getMyPoints(){
			let saasId = localStorage.getItem('saasId')&&localStorage.getItem('saasId')!='null'?localStorage.getItem('saasId'):'';
			let pageSetData = this.$store.state.dynamic.pageSetData;
			let branchId = pageSetData.branchId?pageSetData.branchId:pageSetData.solutionInfo.defaultBranchId?pageSetData.solutionInfo.defaultBranchId:0;
			let params = {
				saasId,
				branchId
			}
			this.$api.account.getYxtIntegralInfoCount({params}).then((res) => {
				if (res.code == 0) {
					this.yxtIntegralInfoCount = res.data;
				}
			})
		},
        getData(){
            let saasId = localStorage.getItem('saasId')&&localStorage.getItem('saasId')!='null'?localStorage.getItem('saasId'):'';
			let pageSetData = this.$store.state.dynamic.pageSetData;
			let branchId = pageSetData.branchId?pageSetData.branchId:pageSetData.solutionInfo.defaultBranchId?pageSetData.solutionInfo.defaultBranchId:0;
			let params = {
				saasId,
				branchId
			}
            this.$api.account.getYxtIntegralInfo({params}).then(res => {
                if (res.data) {
                    this.list = res.data
                }
            })
        },
    },
}
</script>
<style lang="stylus" scoped>
.myPoints{
    min-height 100vh;
    .myPoints-top{
        height :386px;
        background:url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/personal/mypoints.png') no-repeat center center;
        background-size:cover;
        position:relative;
        .myPoints-nav-bar{
            padding:26px 28px 0 24px;
            position relative
            .left-icon{
                position absolute;
                /deep/.van-icon-arrow-left{
                    color #fff;
                    font-size:0.96rem
                }
            }
            .bar-text{
                font-size: 36px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 36px;
                text-align center;
            }
            .pointsRules-text{
                position absolute;
                right 28px;
                top:26px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 36px;
            }
        }
        .total-points{
            position absolute;
            left 50px;
            top:204px;
            font-size: 40px;
            font-family: AvenirNext-Bold, AvenirNext;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 55px;
        }
    }
    .myPoints-content{
        position relative
        top:-52px;
        background #fff;
        border-radius: 24px 24px 0px 0px;
        overflow hidden
        .no-data{
            text-align:center;
            margin-top 90px;
            p{
                color #666666;
                font-size:24px;
            }
        }
        .myPoints-list{
            padding:0 32px;
            .list-item{
                padding:32px 0;
                display flex;
                justify-content space-between
                border-bottom 1px solid #E4E5E6;
                align-items center;
                .info{
                    padding-right 163px;
                    .title{
                        font-size: 32px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 45px;
                        margin-bottom 16px;
                    }
                    .name{
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 40px;
                        margin-bottom 8px;
                    }
                    .time{
                        font-size: 26px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 37px;
                    }
                }
                .integralNum{
                    font-size: 40px;
                    font-family: AvenirNext-DemiBold, AvenirNext;
                    font-weight: 600;
                    color: #3760FF;
                    line-height: 55px;
                }
            }
        }
    }
}
</style>
